import { useFieldState, useForm } from 'form-atoms'
import { useAtomValue } from 'jotai'
import { ArrowDown } from 'lucide-react'
import { useSwapFormActions } from '@/src/stores/swap/actions'
import {
  SWAP_ROUTE_REFETCH_INTERVAL_MS,
  swapFormAtom,
  swapRouteAtom,
  swapRouteQueryEnabledAtom,
} from '@/src/stores/swap/atoms'
import { cn } from '@/src/utils/styles'
import { Button } from '../ui/button'
import { QuoteRemainingTime } from './quote-remaining-time'

export const SwitchSwapButton = () => {
  const { isLoading, isRefetching, error } = useAtomValue(swapRouteAtom)
  const isQueryEnabled = useAtomValue(swapRouteQueryEnabledAtom)
  const { fieldAtoms } = useForm(swapFormAtom)
  const state = useFieldState(fieldAtoms.fromAmount)
  const { switchFromToTokens, prefetchSwitch, isSwitchDisabled } =
    useSwapFormActions()

  const isQuoteAnimationPaused =
    isRefetching || (isLoading && isQueryEnabled) || !state.dirty || !!error

  const shouldShowLoadingSpinner = isLoading && isQueryEnabled

  return (
    <div className='bg-background rounded-full absolute z-10 top-1/2 -translate-y-1/2 mx-auto'>
      <Button
        variant='outline'
        size='sm'
        className={cn('group p-2 size-10 relative')}
        disabled={isSwitchDisabled}
        onMouseEnter={() => {
          if (!isSwitchDisabled) {
            prefetchSwitch()
          }
        }}
        onClick={(e) => {
          e.preventDefault()
          switchFromToTokens()
        }}
      >
        <ArrowDown
          size={24}
          className={cn(
            'm-auto text-tertiary-100 group-disabled:text-tertiary-100 group-hover:text-primary group-focus:text-primary z-10',
            'transition duration-300 ease-default group-hover:rotate-180',
          )}
        />
        <QuoteRemainingTime
          refetchInterval={SWAP_ROUTE_REFETCH_INTERVAL_MS}
          isPaused={isQuoteAnimationPaused}
          className={cn({ invisible: shouldShowLoadingSpinner })}
        />
        <div
          className={cn('absolute -top-px -left-px', {
            visible: shouldShowLoadingSpinner,
            invisible: !shouldShowLoadingSpinner,
          })}
        >
          <div className='animate-[spin_0.7s_linear_infinite] size-10'>
            <div className='size-10 rounded-full bg-background border-1 bg-clip-padding border-transparent before:content-[""] before:absolute before:inset-0 before:-z-[1] xbefore:-m-0.5 before:rounded-[inherit] before:bg-gradient-to-bl before:from-accent-primary before:via-surface2 before:via-60% before:to-transparent' />
          </div>
        </div>
      </Button>
    </div>
  )
}
